module.exports = "<div class=\"container\">\r\n    <app-page-contents [pageName]=\"pageName\"></app-page-contents>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-critical-edition-intro-work/page-critical-edition-intro-work.component.html
// module id = ./src/app/components/pages/page-critical-edition-intro-work/page-critical-edition-intro-work.component.html
// module chunks = main